import { Badge } from "@/components/ui/Badge";
import type { ProductVariantStock } from "@/lib/api-client";

export interface StockBadgeProps {
  stock: ProductVariantStock;
  className?: string;
}

/**
 * Porté à l'identique depuis apps/web/components/product/StockBadge.tsx
 * (aucune dépendance Next.js dans l'original).
 */
export function StockBadge({ stock, className = "" }: StockBadgeProps) {
  if (!stock.inStock) {
    return (
      <div className={["flex flex-wrap items-center gap-2", className].join(" ")}>
        <Badge tone="outOfStock">Rupture de stock</Badge>
        {stock.restockExpectedAt ? (
          <span className="text-xs text-muted">
            Retour prévu le{" "}
            {new Date(stock.restockExpectedAt).toLocaleDateString("fr-FR", {
              day: "numeric",
              month: "long",
            })}
          </span>
        ) : null}
      </div>
    );
  }

  if (stock.lowStock) {
    return (
      <Badge tone="promo" className={className}>
        Plus que {stock.quantityAvailable} en stock
      </Badge>
    );
  }

  return (
    <Badge tone="neutral" className={className}>
      En stock
    </Badge>
  );
}
